import { Container } from "inversify";
import "reflect-metadata";
import AuthenticationInitiator from "./authentication/AuthenticationInitiator";
import { serviceIdentifiers } from "./container-service-identifiers";
import { FirebaseAnalyticsService } from "./core/analytics/FirebaseAnalyticsService";
import { IAnalyticsService } from "./core/analytics/IAnalyticsService";
import GameCanvasStylingService from "./core/cursor/GameCanvasStylingService";
import { IGameCanvasStylingService } from "./core/cursor/IGameCanvasStylingService";
import ExitConfirmationService from "./core/exit-confirmation/ExitConfirmationService";
import FirebaseService from "./core/firebase/FirebaseService";
import { IFirebaseService } from "./core/firebase/IFirebaseService";
import { IFrameBrowserService } from "./core/iframe-browser/IFrameBrowserService";
import { IIFrameBrowserService } from "./core/iframe-browser/IIFrameBrowserService";
import { INavigationService } from "./core/navigation/INavigationService";
import NavigationService from "./core/navigation/NavigationService";

const container = new Container();
container.bind<IFirebaseService>(serviceIdentifiers.IFirebaseService).to(FirebaseService).inSingletonScope();
container.bind<IAnalyticsService>(serviceIdentifiers.IAnalyticsService).to(FirebaseAnalyticsService).inSingletonScope();
container.bind<IIFrameBrowserService>(serviceIdentifiers.IIFrameBrowserService).to(IFrameBrowserService).inSingletonScope();
container.bind<INavigationService>(serviceIdentifiers.INavigationService).to(NavigationService).inSingletonScope();
container.bind<IGameCanvasStylingService>(serviceIdentifiers.IGameCanvasStylingService).to(GameCanvasStylingService).inSingletonScope();
container.bind<AuthenticationInitiator>(serviceIdentifiers.AuthenticationInitiator).to(AuthenticationInitiator).inSingletonScope();
container.bind<ExitConfirmationService>(serviceIdentifiers.ExitConfirmationService).to(ExitConfirmationService).inSingletonScope();


export { container };

